module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-xs-6\"> ")
    ;  if(!locals.disableBack) { 
    ; __append(" <button class=\"btn btn-blue btn-sm prev_page\" type=\"button\"> <i class=\"glyphicon glyphicon-chevron-left\"></i> Previous Page </button> ")
    ;  } 
    ; __append(" </div> <div class=\"col-xs-6\"> <div class=\"pull-right\"> ")
    ;  if(!locals.disableNext) { 
    ; __append(" <button class=\"btn btn-blue btn-sm next_page\" type=\"button\"> Next Page <i class=\"glyphicon glyphicon-chevron-right\"></i> </button> ")
    ;  } 
    ; __append(" </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/pagination_buttons.ejs
// module id = 896
// module chunks = 1